import update from 'immutability-helper';
import {
  SET_CLIENTS,
  ADD_CLIENT
} from '../actionTypes';

const initialState = {
  clients: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_CLIENTS: {
      return action.payload;
    }
    case ADD_CLIENT: {
      const previousClients = state.clients
      const newClients = update(previousClients, {$unshift: [action.payload]});

      return { clients: newClients };
    }
    default:
      return state;
  }
}
